import { useEffect, useRef } from "react";

// Weißer Vollbild-Ladescreen mit der Kluge-Schule-Buch-Animation, gezeigt
// während der Token-Validierung in App.js (Schüler) und ModView.js (Moderator).
//
// Verwendet das Custom Element <ks-book-loader> (geladen via public/index.html
// aus ks-book-loader.js). Das Element hält seine Aufbau-Animation zunächst an
// und startet sie beim Einhängen per play() frisch — dadurch wird der Aufbau
// (Buchdeckel → Seitenlinien) IMMER von Anfang an gezeigt. Die frühere
// <img>-Variante zeigte durch Bild-Caching direkt das fertige Logo.
//
// onDrawn() wird einmal aufgerufen, sobald der Aufbau vollständig ist
// (drawn(), ≈1,1 s; bei prefers-reduced-motion sofort). Der aufrufende Screen
// darf erst weiterschalten, wenn authValidated UND onDrawn eingetreten sind —
// so wird der Aufbau nie abgeschnitten, auch bei sehr schneller Auth.
//
// FALLBACK_MS ist ein Sicherheitsnetz, falls ks-book-loader.js nicht lädt:
// dann nach dieser Zeit trotzdem weiterschalten (Screen hängt nie).
const FALLBACK_MS = 2500;

export default function BookLoaderScreen({ onDrawn }) {
  const elRef = useRef(null);
  const cbRef = useRef(onDrawn);
  cbRef.current = onDrawn;

  useEffect(() => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      if (typeof cbRef.current === "function") cbRef.current();
    };

    const fallback = setTimeout(finish, FALLBACK_MS);

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements
        .whenDefined("ks-book-loader")
        .then(() => {
          const el = elRef.current;
          if (el && typeof el.drawn === "function") {
            el.drawn().then(finish);
          } else {
            finish();
          }
        })
        .catch(finish);
    }

    return () => {
      done = true;
      clearTimeout(fallback);
    };
  }, []); // nur beim Mount

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background: "#ffffff",
      }}
    >
      <ks-book-loader
        ref={elRef}
        label="Wird geladen"
        style={{ width: 220, maxWidth: "60vw" }}
      />
    </div>
  );
}
